import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI
} from '@reduxjs/toolkit';
import { AuthService, isErrorDetails } from '@ianesthesie-kit/services';
import { isOnPrivateRoute } from '@ianesthesie-kit/util';
import { AppConfigService } from '@/config';
import { authRedirectTriggered } from './misc.slice';

const isUnauthenticatedAndShouldRedirect = (payload: unknown) => {
  if (!isErrorDetails(payload)) {
    return false;
  }

  if (payload.status !== 401) {
    return false;
  }

  return payload.status === 401 && isOnPrivateRoute();
};

export const redirectOn401: Middleware =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      if (isUnauthenticatedAndShouldRedirect(action.payload)) {
        if (!AppConfigService.getInstance().env?.startsWith('prod')) {
          console.log('redirectOn401 middleware: logging out');
        }
        AuthService.getInstance()
          .logout()
          .then(() => api.dispatch(authRedirectTriggered()));
      }
    }

    return next(action);
  };
